namespace GeniuzPOS.AdvPromo {
    export class PsAdvPromoItem5ExemptColumns {
        static columnsKey = 'AdvPromo.PsAdvPromoItem5Exempt';
    }
}
